// src/Pages/Category/Category.jsx

import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Auth from "../../Function/Auth";
import { ToastContainer, toast } from "react-toastify";

function Category() {

    const authToken = sessionStorage.getItem("authToken");
    const baseurl = process.env.REACT_APP_BASE_API_URL;

    // =========================
    // STATES
    // =========================

    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);

    // FILTERS
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");

    // ANALYTICS
    const [analytics, setAnalytics] = useState({
        total: 0,
        enable: 0,
        disable: 0
    });

    // =========================
    // ADD CATEGORY STATES
    // =========================

    const [addName, setAddName] = useState("");
    const [addDescription, setAddDescription] = useState("");
    const [addStatus, setAddStatus] = useState("enable");
    const [addImage, setAddImage] = useState(null);
    const [addPreview, setAddPreview] = useState("");

    // =========================
    // EDIT CATEGORY STATES
    // =========================

    const [editCategory, setEditCategory] = useState(null);

    const [editName, setEditName] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editStatus, setEditStatus] = useState("enable");
    const [editImage, setEditImage] = useState(null);
    const [editPreview, setEditPreview] = useState("");

    // =========================
    // LOAD DATA
    // =========================

    useEffect(() => {

        fetchCategories(1);

    }, []);

    // =========================
    // FETCH CATEGORY
    // =========================

    const fetchCategories = async (page = 1) => {

        setLoading(true);

        try {

            const response = await fetch(
                `${baseurl}/category/list?search=${search}&status=${status}&per_page=10&page=${page}`,
                {
                    method: "GET",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = await response.json();

            console.log(data);

            if (data.status) {

                const categoryData = data.data.data || [];

                setCategories(categoryData);

                setPagination(data.data);

                // ANALYTICS
                setAnalytics({
                    total: categoryData.length,
                    enable: categoryData.filter(
                        (x) => x.status === "enable"
                    ).length,
                    disable: categoryData.filter(
                        (x) => x.status === "disable"
                    ).length,
                });
            }

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);
        }
    };

    // =========================
    // SEARCH
    // =========================

    const searchData = () => {

        fetchCategories(1);
    };

    // =========================
    // PAGINATION
    // =========================

    const handlePageChange = (page) => {

        fetchCategories(page);
    };

    // =========================
    // ADD IMAGE
    // =========================

    const handleAddImage = (e) => {

        const file = e.target.files[0];

        setAddImage(file);

        if (file) {

            setAddPreview(
                URL.createObjectURL(file)
            );
        }
    };

    // =========================
    // ADD CATEGORY
    // =========================

    const addCategory = async () => {

        try {

            const formData = new FormData();

            formData.append("name", addName);
            formData.append("description", addDescription);
            formData.append("status", addStatus);

            if (addImage) {
                formData.append("image", addImage);
            }

            const response = await fetch(
                `${baseurl}/category/add`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            if (data.status) {

                toast.success(data.message);

                fetchCategories(1);

                document.getElementById(
                    "closeAddCategoryModal"
                ).click();

                // RESET
                setAddName("");
                setAddDescription("");
                setAddStatus("enable");
                setAddImage(null);
                setAddPreview("");

            } else {

                toast.error(data.message);
            }

        } catch (error) {

            console.log(error);

            toast.error("Something Went Wrong");
        }
    };

    // =========================
    // OPEN EDIT MODAL
    // =========================

    const openEditModal = (category) => {

        setEditCategory(category);

        setEditName(category.name || "");
        setEditDescription(category.description || "");
        setEditStatus(category.status || "enable");

        setEditPreview(category.image || "");

        setEditImage(null);
    };

    // =========================
    // EDIT IMAGE
    // =========================

    const handleEditImage = (e) => {

        const file = e.target.files[0];

        setEditImage(file);

        if (file) {

            setEditPreview(
                URL.createObjectURL(file)
            );
        }
    };

    // =========================
    // UPDATE CATEGORY
    // =========================

    const updateCategory = async () => {

        try {

            const formData = new FormData();

            formData.append(
                "category_id",
                editCategory.id
            );

            formData.append("name", editName);
            formData.append("description", editDescription);
            formData.append("status", editStatus);

            if (editImage) {

                formData.append(
                    "image",
                    editImage
                );
            }

            const response = await fetch(
                `${baseurl}/category/update`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            if (data.status) {

                toast.success(data.message);

                fetchCategories(
                    pagination.current_page
                );

                document.getElementById(
                    "closeEditCategoryModal"
                ).click();

            } else {

                toast.error(data.message);
            }

        } catch (error) {

            console.log(error);

            toast.error("Something Went Wrong");
        }
    };

    return (
        <>

            <Header>

                <Auth />

                <div className="main-content app-content">

                    <div className="container-fluid">

                        {/* PAGE HEADER */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4">

                            <div>

                                <h3 className="fw-bold">
                                    Category Management
                                </h3>

                                <p className="text-muted">
                                    Manage all categories
                                </p>

                            </div>

                            <button
                                className="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#addCategoryModal"
                            >

                                <i className="fa fa-plus me-2"></i>

                                Add Category

                            </button>

                        </div>

                        {/* ANALYTICS */}

                        <div className="row">

                            {/* TOTAL */}
                            <div className="col-md-4">
                                <div className="card overflow-hidden sales-card bg-primary-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            Total Categories
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.total}
                                        </h4>

                                    </div>

                                </div>
                            </div>

                            {/* ENABLED */}
                            <div className="col-md-4">
                                <div className="card overflow-hidden sales-card bg-success-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            Enabled
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.enable}
                                        </h4>

                                    </div>

                                </div>
                            </div>

                            {/* DISABLED */}
                            <div className="col-md-4">
                                <div className="card overflow-hidden sales-card bg-danger-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            Disabled
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.disable}
                                        </h4>

                                    </div>

                                </div>
                            </div>

                        </div>

                        {/* FILTER */}

                        <div className="card">

                            <div className="card-body">

                                <div className="row">

                                    <div className="col-md-5">

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Category"
                                            value={search}
                                            onChange={(e) =>
                                                setSearch(
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </div>

                                    <div className="col-md-5">

                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) =>
                                                setStatus(
                                                    e.target.value
                                                )
                                            }
                                        >

                                            <option value="">
                                                All Status
                                            </option>

                                            <option value="enable">
                                                Enable
                                            </option>

                                            <option value="disable">
                                                Disable
                                            </option>

                                        </select>

                                    </div>

                                    <div className="col-md-2">

                                        <button
                                            className="btn btn-primary w-100"
                                            onClick={searchData}
                                        >
                                            Search
                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* TABLE */}

                        <div className="card">

                            <div className="card-body">

                                <div className="table-responsive">

                                    <table className="table table-bordered">

                                        <thead>

                                            <tr>

                                                <th>Image</th>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Status</th>
                                                <th>Date</th>
                                                <th>Action</th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            {loading ? (

                                                <tr>

                                                    <td
                                                        colSpan="6"
                                                        className="text-center"
                                                    >
                                                        Loading...
                                                    </td>

                                                </tr>

                                            ) : categories.length > 0 ? (

                                                categories.map(
                                                    (
                                                        category,
                                                        index
                                                    ) => (

                                                        <tr key={index}>

                                                            <td>

                                                                <img
                                                                    src={
                                                                        category.image
                                                                    }
                                                                    alt=""
                                                                    width="60"
                                                                    height="60"
                                                                    style={{
                                                                        objectFit:
                                                                            "cover",
                                                                        borderRadius:
                                                                            "10px",
                                                                    }}
                                                                />

                                                            </td>

                                                            <td>
                                                                {
                                                                    category.name
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    category.description
                                                                }
                                                            </td>

                                                            <td>

                                                                {category.status ===
                                                                    "enable" ? (

                                                                    <span className="badge bg-success">
                                                                        Enable
                                                                    </span>

                                                                ) : (

                                                                    <span className="badge bg-danger">
                                                                        Disable
                                                                    </span>

                                                                )}

                                                            </td>

                                                            <td>
                                                                {
                                                                    category.date_time
                                                                }
                                                            </td>

                                                            <td>

                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#editCategoryModal"
                                                                    onClick={() =>
                                                                        openEditModal(
                                                                            category
                                                                        )
                                                                    }
                                                                >

                                                                    <i className="fa fa-edit"></i>

                                                                </button>

                                                            </td>

                                                        </tr>

                                                    )
                                                )

                                            ) : (

                                                <tr>

                                                    <td
                                                        colSpan="6"
                                                        className="text-center"
                                                    >
                                                        No Data Found
                                                    </td>

                                                </tr>

                                            )}

                                        </tbody>

                                    </table>

                                </div>

                                {/* PAGINATION */}

                                <div className="d-flex justify-content-between align-items-center mt-3">

                                    <button
                                        className="btn btn-secondary"
                                        disabled={
                                            pagination.current_page === 1
                                        }
                                        onClick={() =>
                                            handlePageChange(
                                                pagination.current_page - 1
                                            )
                                        }
                                    >
                                        Previous
                                    </button>

                                    <span>
                                        Page{" "}
                                        {
                                            pagination.current_page
                                        }{" "}
                                        of{" "}
                                        {
                                            pagination.last_page
                                        }
                                    </span>

                                    <button
                                        className="btn btn-secondary"
                                        disabled={
                                            pagination.current_page ===
                                            pagination.last_page
                                        }
                                        onClick={() =>
                                            handlePageChange(
                                                pagination.current_page + 1
                                            )
                                        }
                                    >
                                        Next
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* =========================
                ADD CATEGORY MODAL
                ========================= */}

                <div
                    className="modal fade"
                    id="addCategoryModal"
                >

                    <div className="modal-dialog modal-lg modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header bg-primary text-white">

                                <h5 className="modal-title">
                                    Add Category
                                </h5>

                                <button
                                    className="btn-close btn-close-white"
                                    data-bs-dismiss="modal"
                                    id="closeAddCategoryModal"
                                ></button>

                            </div>

                            <div className="modal-body">

                                <div className="row">

                                    <div className="col-md-4 text-center">

                                        <img
                                            src={
                                                addPreview ||
                                                "https://via.placeholder.com/300x300?text=Upload"
                                            }
                                            alt=""
                                            className="img-fluid rounded mb-3"
                                            style={{
                                                height: "250px",
                                                objectFit: "cover",
                                            }}
                                        />

                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={
                                                handleAddImage
                                            }
                                        />

                                    </div>

                                    <div className="col-md-8">

                                        <div className="mb-3">

                                            <label>
                                                Name
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={addName}
                                                onChange={(e) =>
                                                    setAddName(
                                                        e.target.value
                                                    )
                                                }
                                            />

                                        </div>

                                        <div className="mb-3">

                                            <label>
                                                Description
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="5"
                                                value={
                                                    addDescription
                                                }
                                                onChange={(e) =>
                                                    setAddDescription(
                                                        e.target.value
                                                    )
                                                }
                                            ></textarea>

                                        </div>

                                        <div className="mb-3">

                                            <label>
                                                Status
                                            </label>

                                            <select
                                                className="form-control"
                                                value={addStatus}
                                                onChange={(e) =>
                                                    setAddStatus(
                                                        e.target.value
                                                    )
                                                }
                                            >

                                                <option value="enable">
                                                    Enable
                                                </option>

                                                <option value="disable">
                                                    Disable
                                                </option>

                                            </select>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div className="modal-footer">

                                <button
                                    className="btn btn-primary"
                                    onClick={addCategory}
                                >
                                    Add Category
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                {/* =========================
                EDIT CATEGORY MODAL
                ========================= */}

                <div
                    className="modal fade"
                    id="editCategoryModal"
                >

                    <div className="modal-dialog modal-lg modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header bg-dark text-white">

                                <h5 className="modal-title">
                                    Update Category
                                </h5>

                                <button
                                    className="btn-close btn-close-white"
                                    data-bs-dismiss="modal"
                                    id="closeEditCategoryModal"
                                ></button>

                            </div>

                            <div className="modal-body">

                                <div className="row">

                                    <div className="col-md-4 text-center">

                                        <img
                                            src={
                                                editPreview ||
                                                "https://via.placeholder.com/300x300"
                                            }
                                            alt=""
                                            className="img-fluid rounded mb-3"
                                            style={{
                                                height: "250px",
                                                objectFit: "cover",
                                            }}
                                        />

                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={
                                                handleEditImage
                                            }
                                        />

                                    </div>

                                    <div className="col-md-8">

                                        <div className="mb-3">

                                            <label>
                                                Name
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editName}
                                                onChange={(e) =>
                                                    setEditName(
                                                        e.target.value
                                                    )
                                                }
                                            />

                                        </div>

                                        <div className="mb-3">

                                            <label>
                                                Description
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="5"
                                                value={
                                                    editDescription
                                                }
                                                onChange={(e) =>
                                                    setEditDescription(
                                                        e.target.value
                                                    )
                                                }
                                            ></textarea>

                                        </div>

                                        <div className="mb-3">

                                            <label>
                                                Status
                                            </label>

                                            <select
                                                className="form-control"
                                                value={editStatus}
                                                onChange={(e) =>
                                                    setEditStatus(
                                                        e.target.value
                                                    )
                                                }
                                            >

                                                <option value="enable">
                                                    Enable
                                                </option>

                                                <option value="disable">
                                                    Disable
                                                </option>

                                            </select>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div className="modal-footer">

                                <button
                                    className="btn btn-primary"
                                    onClick={updateCategory}
                                >
                                    Update Category
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                <ToastContainer />

            </Header>

            <Footer />

        </>
    );
}

export default Category;